// eslint-disable-next-line no-undef
let baseURL =
process.env.REACT_APP_STAGE === "production"
  ? process.env.REACT_APP_PROD_API_URL
  : process.env.REACT_APP_DEV_API_URL;
let createpath = process.env.REACT_APP_STAGE === "production" ? '/V1/candidate' : '/V1/candidate-easy-apply';
let uploadPath = process.env.REACT_APP_STAGE === "production" ? '/V1/candidateprofileupload' : '/V1/candidateprofileupload-easy-apply';
const URLS = {
  createCandidate: `${baseURL}${createpath}`,
  uploadResume: `${baseURL}${uploadPath}`,
};

export default URLS;
